import ApplicationAdapter from './application';

export default class Announcement extends ApplicationAdapter {
  readAnnouncements() {
    return this.ajax(`${this.buildURL('announcement')}/read-announcements`, 'POST', {});
  }
}
